export const SALE_ADD_PRODUCT = "SALE_ADD_PRODUCT";
export const SALE_REMOVE_PRODUCT = "SALE_REMOVE_PRODUCT";
export const SALE_CHANGE_QUANTITY = "SALE_CHANGE_QUANTITY";
export const SALE_SHOW_PRODUCT_DETAILS = "SALE_SHOW_PRODUCT_DETAILS";
export const SALE_HIDE_PRODUCT_DETAILS = "SALE_HIDE_PRODUCT_DETAILS";
export const SALE_UPDATE_PRODUCTS = "SALE_UPDATE_PRODUCTS";
export const SALE_DISCOUNT_PRODUCT = "SALE_DISCOUNT_PRODUCT";
export const SALE_UNLOCK_PRODUCT = "SALE_UNLOCK_PRODUCT";
export const SALE_REQUEST_ASSOCIATE_BARCODE = "SALE_REQUEST_ASSOCIATE_BARCODE";
export const SALE_ADD_GIFTCARD = "SALE_ADD_GIFTCARD";
export const SALE_TOGGLE_CASE = "SALE_TOGGLE_CASE";
export const SELL_SCREEN_TOGGLE_MOBILE_OPTIONS = "SELL_SCREEN_TOGGLE_MOBILE_OPTIONS";
export const SELL_SCREEN_SEARCH_CHANGE = "SELL_SCREEN_SEARCH_CHANGE";
export const SELL_SCREEN_SEARCH_REPLACE = "SELL_SCREEN_SEARCH_REPLACE";
export const SELL_SCREEN_RESET_SEARCH_CARET = "SELL_SCREEN_RESET_SEARCH_CARET";
export const SELL_SCREEN_SET_SEARCHING = "SELL_SCREEN_SET_SEARCHING";
export const SELL_SCREEN_SEARCH_ADJUST_INDEX = "SELL_SCREEN_SEARCH_ADJUST_INDEX";
export const SELL_SCREEN_CHANGE_ACTION_MODE = "SELL_SCREEN_CHANGE_ACTION_MODE";
export const SELL_SCREEN_CHANGE_SUMMARY_MODE = "SELL_SCREEN_CHANGE_SUMMARY_MODE";
export const SELL_SCREEN_PREVIOUS_ACTION_MODE = "SELL_SCREEN_PREVIOUS_ACTION_MODE";
export const SELL_SCREEN_PREVIOUS_SUMMARY_MODE = "SELL_SCREEN_PREVIOUS_SUMMARY_MODE";
export const SELL_SCREEN_SEARCH_RESULTS_LENGTH = "SELL_SCREEN_SEARCH_RESULTS_LENGTH";
export const SELL_SCREEN_SEARCH_ADJUST_RESULT = "SELL_SCREEN_SEARCH_ADJUST_RESULT";
export const SELL_SCREEN_ACTIVE_PRODUCT_INDEX = "SELL_SCREEN_ACTIVE_PRODUCT_INDEX";
export const SELL_SCREEN_CHANGE_RESULTS_TO = "SELL_SCREEN_CHANGE_RESULTS_TO";
export const SELL_SCREEN_CHANGE_INVALID_INDEXES = "SELL_SCREEN_CHANGE_INVALID_INDEXES";
export const SELL_SCREEN_NEXT_SEARCH_ACTION = "SELL_SCREEN_NEXT_SEARCH_ACTION";
export const SELL_SCREEN_PROMOTION_TYPE_CHANGE = "SELL_SCREEN_PROMOTION_TYPE_CHANGE";
export const SALE_CHANGE_PRICE_SET = "SALE_CHANGE_PRICE_SET";
export const SALE_ADD_NOTE = "SALE_ADD_NOTE";
export const SALE_TOGGLE_DISPLAY_NOTE = "SALE_TOGGLE_DISPLAY_NOTE";
export const SALE_SET_LIVE_PROFIT = "SALE_SET_LIVE_PROFIT";
export const SALE_ADD_ORDER_REFERENCE = "SALE_ADD_ORDER_REFERENCE";
export const SALE_ADD_REFUND_REASON = "SALE_ADD_REFUND_REASON";
export const SALE_CLEAR = "SALE_CLEAR";
export const SALE_RETRIEVE = "SALE_RETRIEVE";
export const SELL_SCREEN_ACTION_MODE_EMBEDDED = "EMBEDDED_APPLICATION";
export const UPDATE_PREVIOUS_SALE = "UPDATE_PREVIOUS_SALE";
export const MARK_PRODUCT_AS_ADDING = "MARK_PRODUCT_AS_ADDING";
export const ADD_INTEGRATED_PRODUCT_TO_SALE = "ADD_INTEGRATED_PRODUCT_TO_SALE";
export const SALE_UPDATE_PRODUCT = "SALE_UPDATE_PRODUCT";
export const SALE_ADD_ACTION = "SALE_ADD_ACTION";
export const SALE_SET_SURCHARGING = "SALE_SET_SURCHARGING";
export const UPDATE_CURRENT_SALE = "UPDATE_CURRENT_SALE";
export const SALE_OVERRIDE_META_DATA = "SALE_OVERRIDE_META_DATA";
export const SALE_SET_CURRENTLY_DISCOUNTING = "SALE_SET_CURRENTLY_DISCOUNTING";
export const SALE_ADD_CUSTOMER = "SALE_ADD_CUSTOMER";
export const SALE_REMOVE_CUSTOMER = "SALE_REMOVE_CUSTOMER";
export const PREVIOUS_SALE_ADD_CUSTOMER = "PREVIOUS_SALE_ADD_CUSTOMER";
export const PREVIOUS_SALE_PRINTED = "PREVIOUS_SALE_PRINTED";
export const SALE_ADD_PAYMENT = "SALE_ADD_PAYMENT";
export const SALE_REVERT_PAYMENT = "SALE_REVERT_PAYMENT";
